module.exports = __webpack_public_path__ + "img/divider-ticket.0b593698.svg";